import { connect } from 'react-redux';
import { openConflictModal } from 'redux/modules/common-modal/actions';
import ChangeSlotType from 'components/Conflict/Resolution/ChangeSlotType/ChangeSlotType';

export default connect(null, {
  onClick: conflict => openConflictModal(conflict),
})(ChangeSlotType);
